import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, Collapse, Divider, Grid, Tab, Tabs } from "@mui/material";
import ThemeContext from "components/app/Context";
import { fetchAssigneeDetailsAsync } from "components/features/MyPlanDetails/MyPlanDetails.slice";
import { fetchMyListDetails, fetchMyLists } from "components/features/SME/home/sme.slice";
import { isEmpty, uniqueId } from "lodash";
import { useContext, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { typography } from "styles/typography";
import { SME_PAGE_SIZE } from "utils/CommonConstants";
import AssignPlanConfirmDialogs from "../AssignPlan/AssignPlanConfirmDialogs";
import Button from "../Button";
import CheckBox from "../Checkbox";
import DialogFormation from "../DialogFormation";
import Scroller from "../Scroller/InfiniteScroller";
import Typography from "../Typography";

interface Prop {
  setOpenAssignPlanDialog: React.Dispatch<React.SetStateAction<boolean>>;
  selectedPlan?: any;
  isPlanDetailView?: boolean;
}

export default function AssignPlanDialog(props: Prop) {
  const dispatch = useAppDispatch();
  const [openDialog, setOpenDialog] = useState<any>({ openAssignPlanDialog: true, openMessageDialog: false });
  const { selectedPlan, setOpenAssignPlanDialog } = props;
  const myLists: any = useAppSelector((state) => state.sme.myLists);
  const myListsInfo: any = useAppSelector((state) => state.sme?.myListDetails?.mappings);
  const [tabValue, setTabValue] = useState(0);
  const { isMobileScreen } = useContext(ThemeContext);
  const [myListsDetails, setMyListsDetails] = useState<any>([]);
  const [expanded, setExpanded] = useState(false);
  const userDetails: any = useAppSelector((state) => state.myPlanDetails.ad);
  const [checkedList, setCheckedList] = useState<any[]>([]);
  const innCode: any = useAppSelector((state) => state.app.innCode);
  const { records, count } = myLists;
  const [page, setPage] = useState(0);

  useEffect(() => {
    if (isEmpty(records)) {
      const props = {
        searchText: "",
        page: 0
      };

      dispatch(fetchMyLists(props)).then((res: any) => {
        if (res?.payload?.innCodeGroups[0]?.id) {
          dispatch(
            fetchMyListDetails({
              id: res?.payload?.innCodeGroups[0]?.id,
              view: "inncodes",
              size: SME_PAGE_SIZE
            })
          );
        }
      });
    }
  }, [records]);

  useEffect(() => {
    if (myListsInfo?.length) {
      setMyListsDetails(myListsInfo?.filter((item: any) => item?.hltId));

      const hltId = myListsInfo?.filter((item: any) => item?.hltId).map((item: any) => item?.hltId);
      const data = {
        value: hltId,
        size: hltId?.length
      };
      if (hltId?.length) dispatch(fetchAssigneeDetailsAsync(data));
    }
  }, [myListsInfo]);

  const handleCloseDialog = () => {
    setOpenAssignPlanDialog(false);
  };

  const handleAssignPlan = () => {
    setOpenDialog({ openAssignPlanDialog: false, openMessageDialog: true });
  };

  const mapOwnerInfo = (ownerCode: string) => {
    return userDetails?.filter((item: any) => item?.hltId === ownerCode)[0];
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
    setCheckedList([]);
    dispatch(fetchMyListDetails({ id: records[newValue]?.id, view: "inncodes", size: SME_PAGE_SIZE }));
  };

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>, value: any, isSelectAll: boolean) => {
    if (isSelectAll && event.target.checked) {
      setCheckedList(myListsDetails);
      return;
    } else if (isSelectAll && !event.target.checked) {
      setCheckedList([]);
      return;
    }
    if (event.target.checked) {
      if (checkedList.findIndex((element: any) => element?.id === value?.id) < 0) {
        setCheckedList((prevState) => [...prevState, value]);
      }
    } else {
      setCheckedList((prevState) => prevState.filter((item: any) => item?.id !== value?.id));
    }
  };

  const fetchMore = () => {
    const props = {
      page: page + 1,
      size: SME_PAGE_SIZE
    };
    dispatch(fetchMyLists(props));
    setPage((pageNo) => pageNo + 1);
  };

  const handleAreaChange = (newValue: number) => {
    setExpanded(false);
    setTabValue(newValue);
    setCheckedList([]);
    dispatch(fetchMyListDetails({ id: records[newValue]?.id, view: "inncodes", size: SME_PAGE_SIZE }));
  };

  return (
    <>
      {openDialog?.openAssignPlanDialog && (
        <DialogFormation
          openDialog={openDialog?.openAssignPlanDialog}
          handleClose={handleCloseDialog}
          title={"Plan Assignment"}
          actionConfig={
            <div className="modal-config-wrapper">
              {checkedList.length ? (
                <Typography
                  variant={"body2"}
                  color={tokens.Icon.General.Secondary}
                  children={checkedList.length + " inncodes selected"}
                ></Typography>
              ) : (
                <Box />
              )}

              <Button disabled={!checkedList.length} variant="primary" label="Next" onClick={handleAssignPlan} />
            </div>
          }
        >
          <Grid container sx={isMobileScreen ? { marginTop: "50px", paddingRight: "15px" } : { marginTop: "10px" }}>
            <Grid item xs={12} md={5} sx={isMobileScreen ? { display: "flex", flexDirection: "row" } : {}}>
              <Grid paddingX={isMobileScreen ? "0" : "8px"} marginY="10px">
                <Typography color={tokens.Icon.General.Secondary} variant="body2">
                  Lists
                </Typography>
              </Grid>
              {isMobileScreen && (
                <Grid item flex="1" sx={{ marginLeft: "16px" }} onClick={() => setExpanded((prevState) => !prevState)}>
                  <Grid
                    container
                    sx={{
                      height: "56px",
                      padding: "18px 16px",
                      backgroundColor: tokens.Background.General.Color,
                      cursor: "pointer"
                    }}
                  >
                    <Grid item flex="1" sx={{ marginRight: "8px" }}>
                      <Typography variant="body2" sx={{ color: tokens.Text.General.Color }}>
                        {records[tabValue]?.name}
                      </Typography>
                    </Grid>
                    <Grid item>
                      {expanded ? (
                        <ExpandLessIcon sx={{ color: tokens.Text.General.Color }} />
                      ) : (
                        <ExpandMoreIcon sx={{ color: tokens.Text.General.Color }} />
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              )}
              {!isMobileScreen && (
                <Box flex={1} maxHeight={"55vh"} sx={{ overflowY: "auto" }} id="listBox">
                  <Scroller
                    dataLength={records?.length}
                    loadMore={fetchMore}
                    totalList={count}
                    label="inncode list"
                    scrollableTarget="listBox"
                  >
                    <Tabs
                      scrollButtons={false}
                      variant="scrollable"
                      visibleScrollbar
                      orientation="vertical"
                      value={tabValue}
                      onChange={handleTabChange}
                      TabIndicatorProps={{ style: { backgroundColor: "transparent" } }}
                    >
                      {records?.map((list: any, index: number) => (
                        <Tab
                          key={list.id}
                          label={list?.name}
                          sx={{
                            color:
                              tabValue === index ? tokens.Icon.General.Primary : tokens.Text.General.PrimaryHeadline,
                            ...typography.body2,
                            alignItems: "flex-start",
                            textAlign: "left",
                            backgroundColor: tabValue === index ? tokens.Background.General.Color : "transparent",
                            marginRight: "8px",
                            "&.MuiTab-root:hover": {
                              backgroundColor: tokens.Background.General.Color,
                              color: tokens.Text.General.Color
                            }
                          }}
                        />
                      ))}
                    </Tabs>
                  </Scroller>
                </Box>
              )}
            </Grid>
            {isMobileScreen && (
              <Collapse in={expanded}>
                {records.map((list: any, index: number) => (
                  <Typography
                    key={uniqueId("LIST_")}
                    variant="body2"
                    sx={{ padding: "16px", color: tokens.Text.General.PrimaryHeadline, cursor: "pointer" }}
                    onClick={() => handleAreaChange(index)}
                  >
                    {list?.name}
                  </Typography>
                ))}
              </Collapse>
            )}

            <Grid paddingLeft="8px" marginTop={isMobileScreen ? "30px" : "10px"} item xs={12} md={7}>
              {isMobileScreen && <Divider />}
              <Grid
                container
                sx={{
                  justifyContent: "flex-start",
                  marginTop: isMobileScreen ? "30px" : "none"
                }}
              >
                <Grid xs={5} md={6} display={"flex"} alignItems={"center"} gap={"8px"}>
                  <CheckBox
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleCheckboxChange(e, {}, true)}
                    sx={{ padding: "0", margin: "0" }}
                    checked={myListsDetails?.length === checkedList?.length && myListsDetails?.length}
                  />
                  <Typography color={tokens.Icon.General.Secondary} variant="body2">
                    Inncodes
                  </Typography>
                </Grid>
                <Grid xs={6} md={6} item>
                  <Typography color={tokens.Icon.General.Secondary} variant="body2">
                    User Name
                  </Typography>
                </Grid>
              </Grid>
              <Box flex={1} maxHeight={"55vh"} sx={{ overflowY: "auto" }}>
                {myListsDetails?.length ? (
                  myListsDetails?.map((item: any) => {
                    const userdetails = mapOwnerInfo(item?.hltId);
                    return (
                      <>
                        <Grid
                          container
                          display={"flex"}
                          alignItems={"center"}
                          justifyContent={"flex-start"}
                          flexDirection={"row"}
                          marginY={isMobileScreen ? "25px" : "14px"}
                        >
                          <Grid
                            xs={5}
                            md={6}
                            alignItems={"center"}
                            gap={"8px"}
                            display={"flex"}
                            flexDirection={"row"}
                            item
                          >
                            <CheckBox
                              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                handleCheckboxChange(e, item, false)
                              }
                              sx={{ padding: "0", margin: "0" }}
                              checked={checkedList.findIndex((el: any) => el?.id === item?.id) >= 0}
                            />
                            <Typography showBold variant="body2" color={tokens.Icon.General.Primary}>
                              {item?.innCode}
                            </Typography>
                          </Grid>

                          <Grid xs={6} md={6} item>
                            <Typography
                              color={tokens.Icon.General.Primary}
                              children={userdetails?.displayName}
                              variant={"body2"}
                            ></Typography>
                          </Grid>
                        </Grid>

                        {!isMobileScreen && <Divider />}
                      </>
                    );
                  })
                ) : (
                  <>
                    <Box display={"flex"} alignItems={"center"} justifyContent={"center"}>
                      <Typography variant={"body2"}>No Record found!</Typography>
                    </Box>
                  </>
                )}
              </Box>
            </Grid>
          </Grid>
        </DialogFormation>
      )}
      {openDialog?.openMessageDialog && (
        <AssignPlanConfirmDialogs
          handleCloseState={setOpenAssignPlanDialog}
          selectedList={checkedList}
          selectedInnCodeGroup={records[tabValue]}
          SelectedPlansList={[selectedPlan]}
          handleBackState={setOpenDialog}
          flowSpecificPayload={{
            isBulkAssignment:
              checkedList?.filter((item: any) => item?.innCode === innCode)?.length === checkedList?.length
                ? false
                : true
          }}
          innCode={innCode}
          onCloseConfirm={() => null}
        />
      )}
    </>
  );
}
